import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export const TicketStubIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ color: '#f8f8f9', opacity: 0.9 }}
    >
      {/* Main ticket body */}
      <path d="M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V8.5C20.1716 8.5 19.5 9.17157 19.5 10C19.5 10.8284 20.1716 11.5 21 11.5V15C21 16.1046 20.1046 17 19 17H5C3.89543 17 3 16.1046 3 15V11.5C3.82843 11.5 4.5 10.8284 4.5 10C4.5 9.17157 3.82843 8.5 3 8.5V5Z" />

      {/* Perforated line */}
      <path d="M9 3V17" strokeDasharray="2 2" />

      {/* Ticket details */}
      <path d="M12 7H18" />
      <path d="M12 10H18" />
      <path d="M12 13H16" />

      {/* Stub details */}
      <path d="M5 7H7" />
      <path d="M5 10H7" />
      <path d="M5 13H7" />
    </svg>
  )
}

export default TicketStubIcon
